import React, { useState, Component } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, MapPinIcon, CalendarIcon, ClockIcon, CreditCardIcon, TagIcon, CheckIcon } from 'lucide-react';
import { Button } from '../components/Button';
import { useApp } from '../context/AppContext';
export const Confirmation: React.FC = () => {
  const navigate = useNavigate();
  const {
    currentRide
  } = useApp();
  const [paymentMethod, setPaymentMethod] = useState('wallet');
  const [promoCode, setPromoCode] = useState('');
  const handleConfirm = () => {
    navigate('/tracking');
  };
  const paymentMethods = [{
    id: 'wallet',
    name: `${currentRide.currency} Wallet`,
    icon: CreditCardIcon
  }, {
    id: 'card',
    name: 'Credit/Debit Card',
    icon: CreditCardIcon
  }, {
    id: 'cash',
    name: 'Cash',
    icon: CreditCardIcon
  }];
  return <div className="min-h-screen bg-background" data-id="element-170">
      <div className="p-6" data-id="element-171">
        <div className="flex items-center mb-6" data-id="element-172">
          <button className="p-2 mr-3" onClick={() => navigate(-1)} data-id="element-173">
            <ArrowLeftIcon size={24} data-id="element-174" />
          </button>
          <h1 className="text-xl font-semibold" data-id="element-175">Confirm your ride</h1>
        </div>
        <div className="card mb-6" data-id="element-176">
          <div className="flex items-start mb-4" data-id="element-177">
            <MapPinIcon size={20} className="text-primary mt-1 mr-3 flex-shrink-0" data-id="element-178" />
            <div data-id="element-179">
              <p className="text-sm text-white text-opacity-70" data-id="element-180">Pickup</p>
              <p className="font-medium" data-id="element-181">{currentRide.pickup?.name}</p>
              <p className="text-sm text-white text-opacity-70" data-id="element-182">
                {currentRide.pickup?.address}
              </p>
            </div>
          </div>
          <div className="flex items-start" data-id="element-183">
            <MapPinIcon size={20} className="text-primary mt-1 mr-3 flex-shrink-0" data-id="element-184" />
            <div data-id="element-185">
              <p className="text-sm text-white text-opacity-70" data-id="element-186">Dropoff</p>
              <p className="font-medium" data-id="element-187">{currentRide.dropoff?.name}</p>
              <p className="text-sm text-white text-opacity-70" data-id="element-188">
                {currentRide.dropoff?.address}
              </p>
            </div>
          </div>
        </div>
        <div className="card mb-6" data-id="element-189">
          <div className="flex items-center justify-between mb-3" data-id="element-190">
            <div className="flex items-center" data-id="element-191">
              <CalendarIcon size={18} className="text-primary mr-2" data-id="element-192" />
              <span data-id="element-193">Today</span>
            </div>
            <button className="text-primary text-sm" data-id="element-194">Change</button>
          </div>
          <div className="flex items-center justify-between" data-id="element-195">
            <div className="flex items-center" data-id="element-196">
              <ClockIcon size={18} className="text-primary mr-2" data-id="element-197" />
              <span data-id="element-198">Now</span>
            </div>
            <div className="chip" data-id="element-199">{currentRide.type}</div>
          </div>
        </div>
        <div className="mb-6" data-id="element-200">
          <h2 className="text-lg font-medium mb-3" data-id="element-201">Payment method</h2>
          <div className="space-y-3" data-id="element-202">
            {paymentMethods.map(method => {
            const IconComponent = method.icon;
            return <div key={method.id} className={`flex items-center justify-between p-4 rounded-lg border ${paymentMethod === method.id ? 'border-primary' : 'border-white border-opacity-20'}`} onClick={() => setPaymentMethod(method.id)} data-id="element-203">
                  <div className="flex items-center" data-id="element-204">
                    <IconComponent size={20} className="text-primary mr-3" data-id="element-205" />
                    <span data-id="element-206">{method.name}</span>
                  </div>
                  {paymentMethod === method.id && <div className="bg-primary rounded-full p-1" data-id="element-207">
                      <CheckIcon size={16} className="text-background" data-id="element-208" />
                    </div>}
                </div>;
          })}
          </div>
        </div>
        <div className="mb-6" data-id="element-209">
          <div className="flex items-center mb-3" data-id="element-210">
            <TagIcon size={18} className="text-primary mr-2" data-id="element-211" />
            <h2 className="text-lg font-medium" data-id="element-212">Promo code</h2>
          </div>
          <div className="flex" data-id="element-213">
            <input type="text" className="input-field flex-1 mr-2" placeholder="Enter promo code" value={promoCode} onChange={e => setPromoCode(e.target.value)} data-id="element-214" />
            <button className="btn-secondary py-3 px-4 w-auto" data-id="element-215">Apply</button>
          </div>
        </div>
        <div className="card mb-8" data-id="element-216">
          <h2 className="text-lg font-medium mb-3" data-id="element-217">Fare details</h2>
          <div className="space-y-2" data-id="element-218">
            <div className="flex justify-between" data-id="element-219">
              <span className="text-white text-opacity-70" data-id="element-220">Base fare</span>
              <span data-id="element-221">
                {currentRide.currency} {(currentRide.price || 0) - 20}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-222">
              <span className="text-white text-opacity-70" data-id="element-223">Checkpoint fee</span>
              <span data-id="element-224">{currentRide.currency} 20</span>
            </div>
            <div className="border-t border-white border-opacity-10 my-2" data-id="element-225"></div>
            <div className="flex justify-between font-semibold" data-id="element-226">
              <span data-id="element-227">Total</span>
              <span className="text-primary" data-id="element-228">
                {currentRide.currency} {currentRide.price}
              </span>
            </div>
          </div>
        </div>
        <Button onClick={handleConfirm} data-id="element-229">Book Ride</Button>
      </div>
    </div>;
};